import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "size--a" }
const _hoisted_2 = { class: "size--c line--last" }

import { PropType } from "vue";
import { Line } from "@/types";
import InnInput from "@/components/ds/input/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLineAmount',
  props: {
    line: {
        type: Object as PropType<Line>,
        required: true,
    },
    locked: {
        type: Boolean,
        required: true,
    },
    currency: {
        type: String,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.locked)
        ? (_openBlock(), _createBlock(InnInput, {
            key: 0,
            placeholder: "Post",
            modelValue: __props.line.text,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.line.text) = $event)),
            compact: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (__props.locked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(__props.line.text), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (!__props.locked)
        ? (_openBlock(), _createBlock(InnInput, {
            key: 0,
            modelValue: __props.line.amount,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.line.amount) = $event)),
            placeholder: "Bedrag",
            compact: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (__props.locked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(__props.line.amount), 1)
          ], 64))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.currency), 1)
    ])
  ], 64))
}
}

})